import { render, staticRenderFns } from "./TableCollapseToggle.vue?vue&type=template&id=4c95bf8c"
import script from "./TableCollapseToggle.vue?vue&type=script&lang=ts"
export * from "./TableCollapseToggle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports